import clsx from 'clsx';
import React from 'react';

interface BadgeProps {
  text: string;
  variant: 'success' | 'danger' | 'info' | 'warning' | 'primary' | 'secondary';
  className?: string;
  style?: any;
}

const Badge: React.FC<BadgeProps> = ({ text, variant, className, style }) => {
  return (
    <span
      className={clsx(`badge ${!style && 'rounded-pill'} bg-${variant} ${className}`)}
      style={style}
    >
      {text}
    </span>
  );
};

export default Badge;
